// extracted by mini-css-extract-plugin
export default {"container":"PresenterItem_container__8KL11","details":"PresenterItem_details__sHE45","avatar":"PresenterItem_avatar__K7Ulf"};